import type { FunctionComponent } from "react";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";

import DevicesImage from "./devices.png";
import {
  Container,
  Description,
  DescriptionContainer,
  DevicesImageContainer,
  HightLightDescription,
  StyledImage,
  StyledMyNewsLink,
  TextContainer,
} from "./styles";

export const SetupCallToAction: FunctionComponent = () => (
  <Container>
    <TextContainer>
      <DescriptionContainer>
        <Description>We curate news that matters to you with our </Description>
        <HightLightDescription>Daily 5 must-read articles</HightLightDescription>
        <Description> plus a comprehensive list of stories from your favourite topics.</Description>
      </DescriptionContainer>
      <StyledMyNewsLink
        onClick={() => {
          sendGATracking({
            action: "My News/Homepage/Setup/Click",
            category: "My News",
          });
        }}
      >
        set up now
      </StyledMyNewsLink>
    </TextContainer>
    <DevicesImageContainer>
      <StyledImage alt={DevicesImage.alt} src={DevicesImage.src} />
    </DevicesImageContainer>
  </Container>
);

SetupCallToAction.displayName = "SetupCallToAction";
